import React from 'react';
import { styled } from 'styled-components';

const UPLOAD_API_URL = import.meta.env.VITE_UPLOAD_API_URL || ''

type AssethThumbnailProps = {
    url: string
}

const ThumbnailWrapper = styled.div`
    height: 74px;
    width: 74px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    padding: 4px;
`


const ThumbnailImage = styled.img`
    height: 64px;
    width: 64px;
    display: block;
    object-fit: cover;
    object-position: center;
    border-radius: 4px;
`

export const AssetThumbnail: React.FC<AssethThumbnailProps> = ({ url }) => {


    return (
        <ThumbnailWrapper>
            <ThumbnailImage
                src={`${UPLOAD_API_URL}/thumbnail?url=${url}`}
            />
        </ThumbnailWrapper>
    );

}